import { hasPermission, type AppPermission, type AppUser } from "../services/authApi";

export const OPERATOR_AUTOMATION_BASE = "/modules/operator-automation";
export const PURCHASE_INVOICES_BASE = "/modules/purchase-invoices";

export type AutomationModule = {
  id: string;
  name: string;
  shortName: string;
  description: string;
  path: string;
  status: "active";
  accent: "green" | "blue" | "violet";
  permission: AppPermission;
};

export const automationModules: AutomationModule[] = [
  {
    id: "operator-automation",
    name: "Saatavuuskyselyt",
    shortName: "SK",
    description: "Elisa-saatavuuskyselyiden luonnin, seurannan ja vastausten automatisointi.",
    path: OPERATOR_AUTOMATION_BASE,
    status: "active",
    accent: "green",
    permission: "operator_automation"
  },
  {
    id: "purchase-invoices",
    name: "Laskudatan käsittely",
    shortName: "LK",
    description: "Laskuaineistojen täsmäytys sekä myyntilaskudatan muodostaminen.",
    path: PURCHASE_INVOICES_BASE,
    status: "active",
    accent: "blue",
    permission: "purchase_invoice_matching"
  }
];

export function modulesForUser(user: AppUser | null | undefined) {
  return automationModules.filter((module) => hasPermission(user, module.permission));
}
